export const processImageData = (imageData, altData) => {
  const allImages = imageData
    .map(({ slug, galleryImages, ...rest }) => {
      // galleryImages is an array, so take the first one here
      const image = galleryImages[0]?.childImageSharp?.gatsbyImageData

      const data = {
        ...rest,
        key: slug,
        image,
        aspectX: image.width,
        aspectY: image.height,
        width: image.width,
        height: image.height,
        aspectRatio: `${image.width} / ${image.height}`,
        orientation: image.width > image.height ? 'horizontal' : 'vertical',
        imageCount: galleryImages.length
      }

      if (altData) {
        data.alt = altData[slug]
      }

      return data
    })
    .filter(n => n)

  const randomisedImages = [...allImages]

  // Randomly shuffle the images array
  for (let i = randomisedImages.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[randomisedImages[i], randomisedImages[j]] = [
      randomisedImages[j],
      randomisedImages[i]
    ]
  }

  return {
    imageData,
    randomisedImages,
    allImages
  }
}
